/// <amd-module name="Build/Extensions/AzureRepos/AzureReposWizard" />
import * as React from "react";

import * as Build from "Build/Client/Contracts/Build";
import { StepCompletedCallback, WizardState } from "Build/Designer/Wizard.types";
import { RepositorySelection } from "Build/Extensions/AzureRepos/RepositorySelection";

import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";

import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";

interface Props {
    wizardState: WizardState;
    onComplete: StepCompletedCallback;
    onUpdate: (action: string, properties?: { [key: string]: any }) => void;
    onTTI: () => void;
}

interface State {
    repositoryId?: string;
    errorMessage?: string;
}

class AzureReposWizard extends VssComponent<Props, State, IVssComponentContext> {
    constructor(props: Props, context: IVssComponentContext) {
        super(props, context);

        this.state = this._getState(props);
    }

    public render(): JSX.Element {
        return (<>
        {
            this.state.errorMessage && <MessageCard className={"azure-repos-wizard-error"} severity={MessageCardSeverity.Error}>
                {this.state.errorMessage}
            </MessageCard>
        }
        {
            this._renderStep()
        }
        </>);
    }

    public componentWillReceiveProps(newProps: Props) {
        this.setState(this._getState(newProps));
    }

    private _renderStep(): JSX.Element {
        return <RepositorySelection
            onSelectRepository={this._onSelectRepository}
            connectionId=""
            sourceProvider={this.props.wizardState.sourceProvider}
            onRepositoryListUpdate={this._onRepositoryListUpdate}
            onTTI={this.props.onTTI}
            onErrorMessage={this._onErrorMessage}/>
    }

    private _onErrorMessage = (error: string): void => {
        this.setState({ errorMessage: error });
    }

    private _onSelectRepository = (repository: Build.SourceRepository, properties: { [key: string]: string }): void => {
        this.setState({
            repositoryId: repository.id
        });

        const updatedState: { [key:string]: string } = {
            repositoryId: repository.id,
            repositoryName: repository.name,
            branch: repository.defaultBranch,
            repositoryUrl: repository.url
        };

        if (repository.properties && repository.properties.repositoryProjectId) {
            updatedState.repositoryProjectId = repository.properties.repositoryProjectId;
        }

        this.props.onComplete(updatedState);
    }

    private _getState(props: Props): State {
        return {
            repositoryId: props.wizardState["repositoryId"]
        }
    }

    private _onRepositoryListUpdate = (action: string, properties?: { [key: string]: any }): void => {
        this.props.onUpdate(action, properties);
    }
}

Components.add("azure-repos-wizard", AzureReposWizard);
